import React, { createContext, useState } from "react";
import { IntlProvider } from "react-intl";
import translations from './translationApi';

let browserLocale = navigator.language;
browserLocale = browserLocale ?? "en_US";

const defaultMessage = await translations.getAllFor(browserLocale.replaceAll('-', '_')) ?? await translations.getAllFor('en_US');

const IntlContext = createContext<Function | null>(null);

const IntlProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  
    const [locale, setLocale] = useState(browserLocale);
    const [messages, setMessages] = useState(defaultMessage);

    const switchLocale: Function = async (locale: string) => {
       const messages = await translations.getAllFor(locale.replaceAll('-', '_')) ?? defaultMessage;
       setLocale(locale.replaceAll('_', '-' ));
       setMessages(messages);
    }

    return (
      <IntlContext.Provider value={switchLocale}>
        <IntlProvider
          locale={locale}
          messages={messages}
          defaultLocale="en-US"
        >
          {children}
        </IntlProvider>
      </IntlContext.Provider>
    );  
}

export { IntlProviderWrapper, IntlContext };